<template>
  <div>
    <div :class="s.logo">
      <img :src="logoUrl" alt="vue" />
    </div>
    <div :class="s.navBar">
      <div :class="s.as">
        <a
          v-for="({ title, to }, index) in navs"
          :key="index"
          :class="[s.mavItem, { [s.heighLight]: index === selected }]"
          @click="changeSelect(index, to)"
        >
          {{ title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import logoUrl from "../images/logo-small.png";
const navs = [
  {
    title: "首页",
    to: "/home",
  },
  {
    title: "关于妙保",
    to: "/about?selected=1",
  },
  {
    title: "企业文化",
    to: "/about?selected=2",
  },
  {
    title: "公开信息披露",
    to: "/about?selected=3",
  },
];
export default {
  computed: {
    s() {
      return this.$style;
    },
  },
  data() {
    return {
      logoUrl,
      navs,
      selected: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const selected = ~~this.$route.query.selected;
      this.selected = selected;
      console.log(this.selected);
    });
  },
  methods: {
    changeSelect(index, to) {
      this.selected = index;
      to && to.length > 1 && this.$router.push(to);
    },
  },
};
</script>

<style scoped lang="less" module>
.logo {
  background-color: #fff;
  padding: 0 344px;
  height: 88px;
  overflow: hidden;
  img {
    display: block;
    height: 40px;
    margin-top: 15px;
  }
}
.navBar {
  height: 58px;
  background-color: #00468c;
  padding: 0 344px;
  //   min-width: 1075px;
  .as {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 1075px;
    margin: 0 auto;
  }
}
.mavItem {
  display: block;
  height: 58px;
  color: #fff;
  line-height: 58px;
  font-size: 14px;
  text-align: center;
  padding: 0 30px;
  font-weight: bold;
  cursor: pointer;
}
.heighLight {
  background-color: #fff;
  color: #00468c;
}
</style>



// WEBPACK FOOTER //
// src/components/components/Header.vue